/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { FileUploader } from '@carbon/react';
import PropTypes from 'prop-types';

import axios from 'axios';
import './fileUpload.scss';

/**
 * Your custom response component can also make use of the message object if you have set "user_defined" variables.
 */
function CustomResponseComponent({ fullMessage, instance }) {
  let files;
  const [filenameStatus, setFilenameStatus] = useState('edit');
  const [labelText, setLabelText] = useState(
    'Max file size is 10MB. Only .docx, .doc, .pdf, .jpeg & .gif files are supported.'
  );
  const [disabled, setDisabled] = useState(false);
  const [fileUploadElement, setFileUploadElement] = useState(null);
  const [error, setError] = useState();

  const upload = (files) => {
    setFilenameStatus('uploading');
    setLabelText('File Uploading...');
    return new Promise((resolve, reject) => {
      const data = new FormData();
      data.append('file_upload', files);

      // Create API_KEY Variable From Context Variable Value
      let ApiKey;
      if (fullMessage?.context?.skills?.['main skill']?.user_defined?.api_key) {
        ApiKey = fullMessage.context.skills['main skill'].user_defined.api_key;
      } else {
        ApiKey = '';
      }

      axios
        .post(
          new URL('eli/upload', process.env.ORCHESTRATION_BASE_URL).href,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
              'X-IBM-Client-ID': `${ApiKey}`,
              'x-api-key': `${ApiKey}`,
            },
          }
        )
        .then((res) => {
          let FileName;
          if (res.data.response.upload[0]) {
            FileName = res.data.response.upload[0].FileName;
          }
          setFilenameStatus('complete');
          setLabelText('File uploaded successfully.');
          setDisabled(true);
          setError();

          // Create Context Variable From Context Variable
          let FullMessageContext;
          if (
            fullMessage?.context?.skills?.['main skill']?.user_defined
              ?.conversation_node?.context
          ) {
            FullMessageContext = {
              ...fullMessage.context.skills['main skill'].user_defined
                .conversation_node.context,
            };
          } else {
            FullMessageContext = {};
          }

          // Create User Defined Context Variable From User Defined Context Variable
          let FullMessageContextUserDefined;
          if (
            fullMessage?.context?.skills?.['main skill']?.user_defined
              ?.conversation_node?.context?.skills?.['main skill']?.user_defined
          ) {
            FullMessageContextUserDefined = {
              ...fullMessage.context.skills['main skill'].user_defined
                .conversation_node.context.skills['main skill'].user_defined,
            };
          } else {
            FullMessageContextUserDefined = {};
          }

          const sendObject = {
            input: {
              message_type: 'text',
              text: '',
            },
            context: {
              skills: {
                'main skill': {
                  user_defined: {
                    assistant_id: `${''}`,
                    conversation_node: {
                      context: {
                        ...FullMessageContext,
                        skills: {
                          'main skill': {
                            ...FullMessageContextUserDefined,
                            user_defined: {
                              file_upload_success: true,
                              document_value: {
                                file_name: FileName,
                                docm_typ_cde: 'Name Change',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          };
          const sendOptions = {
            silent: true,
          };
          instance.send(sendObject, sendOptions).catch(function (error) {
            console.error('This message did not send!');
          });
          resolve(res);
        })
        .catch((error) => {
          setLabelText("Something went wrong, couldn't upload file.");
          setDisabled(true);
          setFilenameStatus('edit');
          setError(error);

          // Create Context Variable From Context Variable
          let FullMessageContext;
          if (
            fullMessage?.context?.skills?.['main skill']?.user_defined
              ?.conversation_node?.context
          ) {
            FullMessageContext = {
              ...fullMessage.context.skills['main skill'].user_defined
                .conversation_node.context,
            };
          } else {
            FullMessageContext = {};
          }

          // Create User Defined Context Variable From User Defined Context Variable
          let FullMessageContextUserDefined;
          if (
            fullMessage?.context?.skills?.['main skill']?.user_defined
              ?.conversation_node?.context?.skills?.['main skill']?.user_defined
          ) {
            FullMessageContextUserDefined = {
              ...fullMessage.context.skills['main skill'].user_defined
                .conversation_node.context.skills['main skill'].user_defined,
            };
          } else {
            FullMessageContextUserDefined = {};
          }

          const sendObject = {
            input: {
              message_type: 'text',
              text: '',
            },
            context: {
              skills: {
                'main skill': {
                  user_defined: {
                    assistant_id: `${''}`,
                    conversation_node: {
                      context: {
                        ...FullMessageContext,
                        skills: {
                          'main skill': {
                            ...FullMessageContextUserDefined,
                            user_defined: {
                              file_upload_success: false,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          };
          const sendOptions = {
            silent: true,
          };
          instance.send(sendObject, sendOptions).catch(function (error) {
            console.error('This message did not send!');
          });
          reject(error);
        });
    });
  };

  return (
    <>
      {fileUploadElement && (
        <div className='cds--file__container'>
          <FileUploader
            accept={['.docx', '.pdf', '.doc', '.jpeg', '.jpg', '.gif']}
            filenameStatus={filenameStatus}
            iconDescription=''
            labelDescription={labelText}
            labelTitle='Upload Document'
            multiple={false}
            name=''
            disabled={disabled}
            onChange={function noRefCheck(event) {
              files = event.target.files;
              files = files[0];
              const length = event.target.files.length;
              const size = event.target.files.size;
              if (files) {
                if (length > 1) {
                  setLabelText(
                    `${length} files selected, you can only upload one file at a time.`
                  );
                } else if (length === 1) {
                  let fileExtension = files.name.split('.').pop();
                  if (
                    fileExtension == 'pdf' ||
                    fileExtension == 'docx' ||
                    fileExtension == 'doc' ||
                    fileExtension == 'jpeg' ||
                    fileExtension == 'jpg' ||
                    fileExtension == 'gif'
                  )
                    if (files.size < 10485760) {
                      setLabelText(files.name);
                      upload(files);
                      setDisabled(true);
                    } else {
                      setLabelText(
                        "File can't be uploaded, should be of type '.pdf', '.docx', '.doc', '.jpeg', '.gif'"
                      );
                    }
                }
                if (files.size < 10485760) {
                  upload(files);
                } else {
                  setLabelText(
                    'Max 10MB files allowed, please select a smaller file size.'
                  );
                }
              }
            }}
            onClick={function noRefCheck(event) {
              event.target.value = null;
            }}
            onDelete={function noRefCheck() {
              if (!error) {
                setDisabled(false);
              }
              setLabelText(
                'Max file size is 10MB. Only .docx, .doc, .pdf, .jpeg & .gif files are supported.'
              );
            }}
            size='md'
          />
        </div>
      )}
      {/* This is where the date picker popup will appear. */}
      <div ref={setFileUploadElement} style={{ position: 'relative' }} />
    </>
  );
}

CustomResponseComponent.propTypes = {
  message: PropTypes.object,
};

export default CustomResponseComponent;
